export default __webpack_public_path__ + "static/media/tidepool_install.441dc49f.png";